module.exports = __webpack_public_path__ + "img/sofa.2ffc253.png";